import React from "react";
import Modal from "react-bootstrap/Modal";
import "./PurchaseConfirmation.css";
import { useDispatch } from "react-redux";
import { Button } from "react-bootstrap";

import { ConfirmedOrder } from "../Redux/ConfirmOrderRedux";

function PurchaseConfirmation(props) {
  const dispatch = useDispatch();
  const SubmitData = () => {
    dispatch(ConfirmedOrder());
  };

  return (
    <Modal {...props} aria-labelledby="contained-modal-title-vcenter" size="md">
      <Modal.Header closeButton className="Titel02">
        <Modal.Title id="contained-modal-title-vcenter">
          Confirmation
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="ArtBox04">
        <br></br>
        <div className="text-center">
          <p>
            On clicking Confirm Your Order will be Confirmed and whole cart will
            be moved to Orders, We will contact You For Payment. <br></br>
            <strong> Thanks For Visiting</strong>
          </p>
        </div>
        <br></br>

        <Button className="Button11" onClick={() => SubmitData()}>
          Confirm
        </Button>
      </Modal.Body>
    </Modal>
  );
}

export default PurchaseConfirmation;
